import './modules/arrange';
import { setNavColorScheme } from './modules/color-scheme';
import { CLASSNAMES, ELEMENTS } from './modules/lib';

const onWindowClick = (e) => {
	const closestOpenLevel = e.target.closest('.lvl--open');
	const closestColorModeSwitch = e.target.closest('.lvl--color-mode');
	if (closestOpenLevel === null && closestColorModeSwitch === null) {
		closeOpenSubMenus();
		window.removeEventListener('click', onWindowClick);
	}
};

const closeOpenSubMenus = () => {
	closeLevel(ELEMENTS.openSubMenuListItem());
};

const levelIsOpen = (listItem) => listItem.classList.contains(CLASSNAMES.levelOpen);

const openSubMenu = (listItem) => {
	// Prevent multiple first level nav items from being open at the same time
	closeOpenSubMenus();
	listItem.classList.add(CLASSNAMES.levelOpen);

	// Focus search input when opening submenu
	if (listItem === ELEMENTS.searchListItem()) {
		ELEMENTS.searchListItem().querySelector('input')?.focus();
	}

	ELEMENTS.nav().dispatchEvent(new CustomEvent('subMenuChange'));

	// Register event listener on the window level to close submenu when clicking outside
	window.addEventListener('click', onWindowClick);
};

const openLevel = (listItem) => {
	// Prevent multiple first level nav items from being open at the same time
	ELEMENTS.openLevelListItem()?.classList.remove(CLASSNAMES.levelOpen);
	listItem.classList.add(CLASSNAMES.levelOpen);
};

const closeLevel = (listItem) => {
	if (!listItem) return;
	listItem.classList.remove(CLASSNAMES.levelOpen);
	ELEMENTS.nav().dispatchEvent(new CustomEvent('subMenuChange'));
};

// Open stage when button is clicked
ELEMENTS.subMenuTriggerButtons().forEach((button) => {
	button.addEventListener('click', () => {
		const listItem = button.closest('li');

		// Open or close the level
		levelIsOpen(listItem) ? closeLevel(listItem) : openSubMenu(listItem);
	});
});

ELEMENTS.levelTriggerButtons().forEach((button) => {
	button.addEventListener('click', () => {
		const listItem = button.closest('li');

		// Open or close the level
		levelIsOpen(listItem) ? closeLevel(listItem) : openLevel(listItem);
	});
});

// Handle the color scheme
['scroll', 'DOMContentLoaded', 'resize'].forEach((type) => {
	window.addEventListener(type, setNavColorScheme);
});

ELEMENTS.nav().addEventListener('subMenuChange', setNavColorScheme);
